<template>
  <v-card class="dialog">
    <v-card-title class="primary">
      <span v-if="idTipoCancelamento === 1 && page >= 2" class="headline">
        CANCELAMENTO DA APOLICE</span
      >
      <span v-else-if="idTipoCancelamento === 2 && page >= 6" class="headline">
        CANCELAMENTO DO ENDOSSO</span
      >
      <span v-else class="headline"> ENDOSSO DE CANCELAMENTO</span>
    </v-card-title>
    <v-card-text class="py-5 px-4">
      <v-layout row wrap v-if="page === 1">
        <v-form v-model="validTipoCancelamento">
          <v-radio-group
            :hide-details="true"
            required
            v-model="idTipoCancelamento"
            :rules="regras.notNull"
          >
            <v-flex py-3 v-for="item in tipoEndossoList" :key="item.titulo"
              ><v-radio :value="item.id">
                ><template v-slot:label>
                  <div class="textblack" style="font-size: 14px">
                    <b>{{ item.titulo }}</b>
                  </div>
                </template>
              </v-radio>
            </v-flex>
          </v-radio-group>
        </v-form>
      </v-layout>

      <v-layout column row v-else-if="page === 2">
        <v-form ref="formulario" v-model="validMotivoEndosso">
          <v-layout>
            <v-flex xs6 sm5 md4>
              <v-select
                label="Motivo do Endosso"
                placeholder="Selecione uma opção"
                v-model="idMotivoEndosso"
                :rules="regras.notNull"
                item-text="titulo"
                item-value="id"
                :items="motivoEndossoList"
                required
              ></v-select>
            </v-flex>
            <v-flex xs6 sm5 md4 class="ml-4">
              <v-menu
                ref="dataCancelamentoMenu"
                v-model="dataCancelamentoMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="textInicio"
                    label="Data do Cancelamento"
                    prepend-icon="event"
                    v-on="on"
                    :rules="regras.notNull"
                    readonly
                  ></v-text-field>
                </template>
                <v-date-picker
                  @change="onDateChange"
                  v-model="dataCancelamento"
                  no-title
                  required
                  scrollable
                >
                </v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>

          <v-flex xs12>
            <v-textarea
              name="textarea"
              label="Breve descrição da operação (Texto Livre):"
              v-model="textoLivreEndosso"
              background-color="white"
            ></v-textarea>
          </v-flex>
        </v-form>
      </v-layout>

      <v-layout column row v-else-if="page === 3">
        <v-layout>
          <v-flex class="themeGrey--text" pb-3>Endosso(s) a cancelar</v-flex>
        </v-layout>
        <v-layout align-center justify-right row>
          <v-spacer></v-spacer>
          <v-flex class="body-2"> NÚMERO COTAÇÃO </v-flex>
          <v-spacer></v-spacer>
          <v-flex class="body-2"> TOTAL PRÊMIO </v-flex>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-flex class="body-2"> QTD. ÍTENS </v-flex>
        </v-layout>
        <v-layout align-center justify-right row>
          <v-flex md2></v-flex>
          <v-flex md4 class="body-2">
            {{ apoliceList.apoliceNumeroCotacao }}
          </v-flex>
          <v-flex md5 class="body-2">
            R$ {{ apoliceList.totalPremioLiquido }}
          </v-flex>

          <v-flex md2 class="body-2">
            {{ apoliceList.quantidadeItens }}
          </v-flex>
        </v-layout>
      </v-layout>

      <v-layout column row v-else-if="page === 4">
        <v-layout>
          <v-flex class="themeGrey--text" pb-3>Endosso(s) a cancelar</v-flex>
        </v-layout>
        <v-layout align-center justify-right row>
          <v-spacer></v-spacer>
          <v-flex class="body-2"> NÚMERO COTAÇÃO </v-flex>
          <v-spacer></v-spacer>
          <v-flex class="body-2"> TOTAL PRÊMIO </v-flex>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-flex class="body-2"> QTD. ÍTENS </v-flex>
        </v-layout>
        <v-layout align-center justify-right row>
          <v-flex md2></v-flex>
          <v-flex md4 class="body-2">
            {{ apoliceList.apoliceNumeroCotacao }}
          </v-flex>
          <v-flex md5 class="body-2">
            R$ {{ apoliceList.totalPremioLiquido }}
          </v-flex>

          <v-flex md2 class="body-2">
            {{ apoliceList.quantidadeItens }}
          </v-flex>
        </v-layout>
        <v-layout row column>
          <v-layout py-3>
            <v-flex class="themeGrey--text">Cálculo de restituição</v-flex>
          </v-layout>
          <v-layout>
            <v-flex>SALDO A RESTITUIR:</v-flex>
            <v-flex>R$ {{ total }}</v-flex>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
          </v-layout>
        </v-layout>
      </v-layout>

      <v-layout column row v-else-if="page === 5">
        <v-layout wrap>
          <v-layout>
            <v-flex class="themeGrey--text" pb-3
              >Tem certeza de que deseja emitir ou salvar o cancelamento da
              apólice? Uma vez realizada a operação, não sera possível
              reverter.</v-flex
            >
          </v-layout>
        </v-layout>
      </v-layout>

      <v-layout column row v-else-if="page === 6">
        <v-form ref="formula" v-model="validEndosso">
          <v-layout>
            <v-flex class="themeGrey--text" pb-3>Endosso(s) a cancelar</v-flex>
          </v-layout>
          <v-layout align-center justify-right row>
            <v-flex md1></v-flex>
            <v-flex class="special-flex" md3>
              <p class="body-2 mb-0">N. EMISSÃO ENDOSSO</p>
            </v-flex>
            <v-flex class="special-flex" md3>
              <p class="body-2 mb-0">VLR. ENDOSSO</p>
            </v-flex>
            <v-flex class="special-flex" md3>
              <p class="body-2 mb-0">QTD. ÍTENS</p>
            </v-flex>
            <v-flex class="special-flex" md2>
              <p class="body-2 mb-0">TIPO DO ENDOSSO</p>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex md1>
              <v-radio-group
                class="check-endosso"
                :hide-details="true"
                required
                :rules="regras.notNull"
                v-model="selected"
              >
                <v-flex v-for="item in endossoList" :key="item.numeroRevisao"
                  ><v-radio :value="item">
                    ><template v-slot:label> </template>
                  </v-radio>
                </v-flex>
              </v-radio-group>
            </v-flex>
            <v-layout column>
              <v-layout
                justify-center
                align-left
                v-for="item in endossoList"
                :key="item.numeroRevisao"
              >
                <v-flex md1></v-flex>
                <v-flex md3 class="check-endosso special-flex">
                  {{ item.numeroRevisao }}
                </v-flex>
                <v-flex md3 class="check-endosso special-flex">
                  R$ {{ item.vlrEndosso }}
                </v-flex>
                <v-flex md3 class="check-endosso special-flex">
                  {{ item.itemExcInc }}
                </v-flex>
                <v-flex md2 class="special-flex">
                  {{ formatTipoEndosso(item.idTipoEndosso) }}
                </v-flex>
              </v-layout>
            </v-layout>
          </v-layout>
        </v-form>
      </v-layout>
      <v-layout column row v-else-if="page === 7">
        <v-form ref="formula" v-model="validarMotivoEndossoCancelar">
          <v-layout>
            <v-flex xs12 sm5 md4>
              <v-select
                label="Motivo do Endosso"
                placeholder="Selecione uma opção"
                v-model="idMotivoEndosso"
                item-text="titulo"
                item-value="id"
                :items="motivoEndossoList"
                :rules="regras.notNull"
                required
              ></v-select>
            </v-flex>
          </v-layout>

          <v-flex xs6>
            <v-textarea
              name="textarea"
              label="Breve descrição da operação (Texto Livre):"
              v-model="textoLivreEndosso"
              background-color="white"
            ></v-textarea>
          </v-flex>
        </v-form>
      </v-layout>
      <v-layout column row v-else-if="page === 8">
        <v-form ref="formula" v-model="validar">
          <v-layout>
            <v-flex class="themeGrey--text" pb-3>Endosso(s) a cancelar</v-flex>
          </v-layout>
          <v-layout align-center justify-right row>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-flex class="body-2"> N. EMISSÃO ENDOSSO </v-flex>
            <v-spacer></v-spacer>
            <v-flex class="body-2"> VLR. ENDOSSO </v-flex>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-flex class="body-2"> QTD. ÍTENS </v-flex>
            <v-spacer></v-spacer>
            <v-flex class="body-2"> TIPO DO ENDOSSO </v-flex>
          </v-layout>
          <v-layout align-center justify-right row>
            <v-layout row align-center wrap>
              <v-flex md2></v-flex>
              <v-flex md3 class="check-endosso">
                {{ selected.numeroRevisao }}
              </v-flex>
              <v-flex md3 class="check-endosso">
                R$ {{ selected.vlrEndosso }}
              </v-flex>

              <v-flex md1 class="check-endosso">
                {{ selected.itemExcInc }}
              </v-flex>
              <v-flex> </v-flex>
              <v-flex>
                {{ formatTipoEndosso(selected.idTipoEndosso) }}
              </v-flex>
            </v-layout>
          </v-layout>
          <v-layout row column>
            <v-layout py-3>
              <v-flex class="themeGrey--text">Cálculo de restituição</v-flex>
            </v-layout>

            <v-layout>
              <v-flex>SALDO A RESTITUIR:</v-flex>
              <v-flex>R$ {{ total }}</v-flex>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
            </v-layout>
          </v-layout>
        </v-form>
      </v-layout>
      <v-layout column row v-else-if="page === 9">
        <v-form ref="formula" v-model="validar">
          <v-layout wrap>
            <v-layout>
              <v-flex class="themeGrey--text" pb-3
                >Tem certeza de que deseja emitir ou salvar o cancelamento do
                endosso?</v-flex
              >
            </v-layout>
            <v-snackbar v-model="snack" :timeout="3500" :color="snackColor">
              {{ snackText }}
            </v-snackbar>
          </v-layout>
        </v-form>
      </v-layout>
      <v-layout row justify-center>
        <v-dialog persistent v-model="erro" max-width="600px">
          <v-card class="dialog">
            <v-card-title class="primary">
              <span class="headline">CANCELAMENTO NEGADO</span>
            </v-card-title>
            <v-card-text class="px-5 pb-5">
              <div grid-list-md>
                <v-layout wrap>
                  <v-flex align-center d-flex xs12>
                    <span class="themeGrey--text">
                      Não será possivel prosseguir com o cancelamento. Conforme
                      consulta na nossa parceira Essor, não foram encontradas
                      parcelas quitadas para esta apólice.
                    </span>
                  </v-flex>
                </v-layout>
              </div>
              <v-layout row wrap>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>

                <v-btn
                  class="primary"
                  flat
                  @click="fecharDialogEndossoCancelamento"
                >
                  OK
                </v-btn>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-card-text>
    <v-card-actions class="px-5 pb-5">
      <v-spacer></v-spacer>
      <v-btn color="primary" flat @click="fecharDialogEndossoCancelamento">
        CANCELAR
      </v-btn>
      <v-btn
        color="primary"
        flat
        @click="page = page - 1"
        v-if="page > 1 && page < 6"
      >
        VOLTAR
      </v-btn>
      <v-flex md6 xs12 v-if="idTipoCancelamento === 2 ? page >= 6 : page >= 2">
        <v-btn
          color="primary"
          flat
          @click="page = page - 5"
          v-if="page > 5 && page <= 6"
        >
          VOLTAR
        </v-btn>
        <v-btn color="primary" flat @click="page = page - 1" v-if="page >= 7"
          >VOLTAR</v-btn
        >
      </v-flex>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-btn
        class="primary"
        :disabled="!validTipoCancelamento"
        v-if="page === 1"
        @click="listarCancelaveis"
      >
        PRÓXIMO
      </v-btn>
      <v-flex
        md6
        xs12
        class="custom-flex-spacing"
        v-if="idTipoCancelamento === 1 && page >= 2"
      >
        <v-btn
          class="primary"
          :disabled="!validMotivoEndosso"
          @click="validaCamposApolice"
          v-if="idTipoCancelamento === 1 && page <= 2"
          >PRÓXIMO</v-btn
        >
        <v-btn
          class="button-custom"
          flat
          v-else-if="page <= 3"
          @click="calcularCancelamento()"
          >PRÓXIMO</v-btn
        >
        <v-btn
          class="primary"
          v-if="idTipoCancelamento === 1 && page == 4"
          @click="salvarEndossoCancelamento()"
        >
          SALVAR
        </v-btn>
        <v-btn
          class="primary"
          v-if="page == 4"
          :disabled="total > 0"
          @click="page = page + 1"
        >
          EMITIR CANCELAMENTO
        </v-btn>
        <v-btn
          class="primary"
          :disabled="total > 0"
          @click="emitirEndossoCancelamento()"
          v-else-if="page == 5"
        >
          CONFIRMAR
        </v-btn>
      </v-flex>
      <v-flex
        md6
        class="custom-flex-spacing"
        v-if="idTipoCancelamento === 2 && page >= 6"
      >
        <v-btn
          class="primary"
          :disabled="
            page == 7 ? !validarMotivoEndossoCancelar : !selected.numeroRevisao
          "
          @click="validaCamposEndosso && calcularCancelamento()"
          v-if="idTipoCancelamento === 2 && page === 7"
        >
          PRÓXIMO
        </v-btn>
        <v-btn
          class="primary"
          :disabled="
            page == 7 ? !validarMotivoEndossoCancelar : !selected.numeroRevisao
          "
          @click="validaCamposEndosso"
          v-if="idTipoCancelamento === 2 && page === 6"
        >
          PRÓXIMO
        </v-btn>
        <v-btn
          class="primary"
          v-if="idTipoCancelamento === 2 && page == 8"
          @click="salvarEndossoCancelamento()"
        >
          SALVAR
        </v-btn>

        <v-btn
          class="primary"
          @click="page = page + 1"
          :disabled="total > 0"
          v-if="idTipoCancelamento === 2 && page > 7 && page <= 8"
        >
          EMITIR CANCELAMENTO
        </v-btn>
        <v-btn
          class="primary"
          v-if="page == 9"
          :disabled="total > 0"
          @click="emitirEndossoCancelamento()"
        >
          CONFIRMAR
        </v-btn>
        <v-btn
          class="primary"
          v-if="page == 10"
          @click="fecharDialogEndossoCancelamento()"
        >
          OK
        </v-btn>
      </v-flex>
    </v-card-actions>
    <v-snackbar v-model="snack" :timeout="3500" :color="snackColor">
      {{ snackText }}
    </v-snackbar>
  </v-card>
</template>

<script>
import axios from "axios";
import usuarioHelper from "@/helpers/usuario-logado.js";
import moment from "moment";

export default {
  name: "ModalEndossoCancelamento",
  data: () => ({
    dataCancelamentoMenu: false,
    dataCancelamento: null,
    idTipoCancelamento: null,
    motivoEndossoList: [],
    endossoList: [],
    habilitarBotao: true,
    valid: true,
    validar: true,
    apoliceList: {},
    apoliceRevisao: {},
    totalRestituicao: null,
    date: null,
    total: null,
    selected: {},
    snack: null,
    erroAjuda: null,
    snackText: null,
    snackColor: null,
    validMotivoEndosso: true,
    relacionavelList: [],
    textoLivreEndosso: null,
    apoliceDescricao: null,
    erro: false,
    validTipoCancelamento: true,
    endossoDescricao: null,
    errorMessage: null,
    idMotivoEndosso: null,
    page: 1,
    validEndosso: true,
    validarMotivoEndossoCancelar: true,
    tipoEndossoList: [
      {
        id: 1,
        titulo: "Cancelar toda a apólice"
      },
      {
        id: 2,
        titulo: "Cancelar endosso"
      }
    ],
    regras: {
      notNull: [v => !!v || "Você não pode deixar este campo em branco"],
      cnpj: [v => !!String(v).match(/^[A-Za-z0-9]{12}\d{2}$/) || "CNPJ incorreto"],
      cep: [v => !!String(v).match(/^\d{8}$/) || "CEP incorreto"]
    }
  }),
  props: {
    idApolice: Number
  },
  computed: {
    textInicio() {
      return this.dataCancelamento == null ? null : new Date(this.dataCancelamento).toLocaleDateString("pt-BR", {
        timeZone: "UTC",
        year: "numeric",
        month: "long",
        day: "numeric"
      });
    }
  },
  mounted() {
    this.buscarApolice();
    this.buscarOpcoes();
  },
  methods: {
    onDateChange: function() {
      const self = this;
      const date = self.dataCancelamento.split("-");
      const ano = pafseInt(date[0]) + 1;
      const newDateFim = date.concat(ano + "-" + date[1] + "-" + date[2]);
      this.dateFim = newDateFim[3];
    },
    listarCancelaveis() {
      this.idTipoCancelamento === 1
        ? (this.page = this.page + 1) && this.buscarApoliceRevisao()
        : (this.page = this.page + 5);
      if (this.idTipoCancelamento != null) {
        this.buscarEndossos();
      }
    },
    formatTipoEndosso(tipo) {
      if (tipo == 1) return "COBRANÇA";
      if (tipo == 2) return "RESTITUIÇÃO";
      if (tipo == 3) return "SEM MOVIMENTAÇÃO";
      if (tipo == 4) return "CANCELAMENTO";
      if (tipo == 5) return "SUBSTITUIÇÃO";
    },
    listarRelacionaveis() {
      axios
        .get(
          `${process.env.URL_ENDOSSOMS}/v1/listarRelacionaveis/${this.idApolice}`,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          }
        )
        .then(response => {
          this.relacionavelList = response.data;
        })
        .catch(err => {
          throw err;
        });
    },

    fecharDialogEndossoCancelamento() {
      this.$emit("fecharDialogEndossoCancelamento");
    },

    buscarOpcoes() {
      axios
        .get(`${process.env.URL_APOLICEMS}/v1/motivoEndosso`, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        })
        .then(response => {
          this.motivoEndossoList = response.data;
        })
        .catch(err => {
          throw err;
        });
    },
    fecharDialog() {
      this.$emit("fecharDialog");
    },

    listarSelecionado() {
      return this.endossoList.filter(item => item.selected);
    },

    formatDate(date) {
      if (date) {
        var formatedDate = moment(date).format("YYYY-MM-DD");
        return formatedDate;
      }
    },

    objetoCalculo() {
      const calculoEndosso = {
        codigoCancelamento: this.idTipoCancelamento,
        idEndosso:
          this.idTipoCancelamento === 1
            ? this.apoliceRevisao.idEndosso
            : this.selected.idEndosso,
        numeroRevisao:
          this.idTipoCancelamento === 1
            ? this.apoliceRevisao.numeroRevisao
            : this.selected.numeroRevisao,
        idTipoEndosso: 4,
        dateInicio: moment(new Date()).format("YYYY-MM-DD"),
        dataCancelamento: this.dataCancelamento
      };
      return calculoEndosso;
    },

    calcularCancelamento() {
      this.erro = false;
      this.$emit("ativarLoader")
      axios
        .post(
          `${process.env.URL_ENDOSSOMS}/v1/calcularEndosso/${this.idApolice}`,
          this.objetoCalculo(),
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          }
        )
        .then(response => {
          this.total = response.data.totalRestituicao;
          this.page = this.page + 1;
        })
        .catch(error => {
          this.erro = true;
          this.snack = true;
          this.snackColor = "error";
          error.response.data.message
            ? (this.snackText = error.response.data.message)
            : (this.snackText = "generico");
      this.$emit("desativarLoader")

        });
      this.$emit("desativarLoader")

    },

    buscarEndossos() {
      axios
        .get(
          `${process.env.URL_ENDOSSOMS}/v1/listaCancelaveis/${this.idApolice}?idTipoCancelamento=${this.idTipoCancelamento}`,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          }
        )
        .then(response => {
          this.endossoList = response.data;
          if (response.data.length == 0) {
            this.snack = true;
            this.snackColor = "error";
            this.snackText = "Nao foram encontrados endossos cancelaveis";
          }
        })
        .catch(error => {
          this.erro = true;
          this.snack = true;
          this.snackColor = "error";
          this.snackText =
            error.response.data.message == null
              ? "Nao foram encontrados endossos cancelaveis"
              : error.response.data.message;
        });
    },

    async buscarApoliceRevisao() {
      const response = await axios.get(
        `${process.env.URL_ENDOSSOMS}/v1/buscarApoliceRevisao/${this.idApolice}`,
        {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        }
      );
      this.apoliceRevisao = response.data;
    },

    validaCamposApolice() {
      if (this.$refs.formulario.validate()) {
        this.page = this.idTipoCancelamento === 1 ? this.page + 1 : 6;
      }
    },
    emitirEndossoCancelamento() {
      this.$emit("ativarLoader")

      var dadosAtualizados = {
        codigoCancelamento: this.idTipoCancelamento,
        idTipoEndosso: 4,
        idEndosso:
          this.idTipoCancelamento === 1
            ? this.apoliceRevisao.idEndosso
            : this.selected.idEndosso,
        textoLivreEndosso: this.textoLivreEndosso,
        dateInicio: this.dateInicio,
        idMotivoEndosso: this.idMotivoEndosso,
        numeroRevisao:
          this.idTipoCancelamento === 1
            ? this.apoliceRevisao.numeroRevisao
            : this.selected.numeroRevisao,
        dataCancelamento : this.dataCancelamento
      };
      axios
        .post(
          `${process.env.URL_ENDOSSOMS}/v1/emitirEndosso/${this.idApolice}`,
          dadosAtualizados,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          }
        )
        .then(() => {
          this.snack = true;
          this.snackText = "Informações recebidas com sucesso.";
          this.snackColor = "success";
          setTimeout(() => {
            this.fecharDialogEndossoCancelamento();
          }, 2000);
        })
        .catch(error => {
          this.dialogError = true;
          this.$emit("desativarLoader")

          this.errorMessage = error.response
            ? error.response.data.message
            : "Não foi possível emitir o endosso de cancelamento.";
        });
        this.$emit("desativarLoader")

    },

    salvarEndossoCancelamento() {
      this.$emit("ativarLoader")

      var dadosAtualizados = {
        codigoCancelamento: this.idTipoCancelamento,
        idTipoEndosso: 4,
        idEndosso:
          this.idTipoCancelamento === 1
            ? this.apoliceRevisao.idEndosso
            : this.selected.idEndosso,
        textoLivreEndosso: this.textoLivreEndosso,
        dateInicio: this.dateInicio,
        idMotivoEndosso: this.idMotivoEndosso,
        numeroRevisao:
          this.idTipoCancelamento === 1
            ? this.apoliceRevisao.numeroRevisao
            : this.selected.numeroRevisao,
        naoEmitirValorRestituido: true,
        dataCancelamento: this.dataCancelamento
      };
      axios
        .post(
          `${process.env.URL_ENDOSSOMS}/v1/salvarEndossoCancelamento/${this.idApolice}`,
          dadosAtualizados,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          }
        )
        .then(() => {
          this.snack = true;
          this.snackText = "Informações recebidas com sucesso.";
          this.snackColor = "success";
          setTimeout(() => {
            this.fecharDialogEndossoCancelamento();
          }, 2000);
        })
        .catch(error => {
          this.dialogError = true;
          this.$emit("desativarLoader")

          this.errorMessage = error.response
            ? error.response.data.message
            : "Não foi possível salvar o endosso de cancelamento.";
        });
        this.$emit("desativarLoader")

    },
    validaCamposEndosso() {
      if (this.$refs.formula.validate()) {
        this.page = this.idTipoCancelamento === 2 ? this.page + 1 : 2;
      }
    },

    async buscarApolice() {
      const response = await axios.get(
        `${process.env.URL_APOLICEMS}/v1/buscarApolice/${this.idApolice}`,
        {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        }
      );
      this.apoliceList = response.data;
    }
  }
};
</script>

<style>
.check-endosso {
  margin-top: 0px;
  width: 500px;
  display: flex;
  align-items: center;
}

.special-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.table-grid thead {
  background-color: #00456e;
}
.table-grid .column {
  color: #fff !important;
}

.table-grid th i {
  color: #fff !important;
}

.dialog {
  background: #eaeaea !important;
}

.headline {
  color: #fff;
  font-size: 14px !important;
}

.text-error {
  color: #f45353;
  font-weight: bold;
}

.name-arquivo {
  width: 90%;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 10px 10px;
  background-color: #fff;
  border-radius: 2px;
}

input[type="file"] {
  display: none;
}

.button-custom {
  width: 100%;
  max-width: 180px;
  text-align: center;
  color: #fff !important;
  background-color: #00456e;
  border-radius: 2px;
  display: inline-block;
  padding: 9px 12px;
  cursor: pointer;

  font-weight: bold;
}

.button-custom:hover {
  background-color: #063f57;
}

.disabled,
.v-btn.button-custom:disabled {
  cursor: default;
  background-color: #063f57;
  color: #aaaaaa !important;
}

.disabled:hover {
  background-color: #063f57;
}

.click {
  cursor: pointer;
}
.size {
  size: 1;
}

.custom-flex-spacing {
  display: flex;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/frota/ModalEndossoCancelamento.vue